(function () {
  'use strict';

  var ALLOWED_MODES = [
    'STANDARD',
    'BULK',
    'CUSTOM',
    'NEED_HELP',
    'CHECK_AVAILABILITY',
    'QUOTE_REQUIRED',
    'ENGINEERING_REVIEW'
  ];
  var MODE_LABELS = {
    STANDARD: 'Standard O-ring',
    BULK: 'Bulk quantity',
    CUSTOM: 'Custom requirement',
    NEED_HELP: 'Selection or document help',
    CHECK_AVAILABILITY: 'Availability confirmation',
    QUOTE_REQUIRED: 'Quotation review',
    ENGINEERING_REVIEW: 'Engineering review'
  };
  var INQUIRY_BY_MODE = {
    STANDARD: 'Standard O-Rings',
    BULK: 'Bulk quantity',
    CUSTOM: 'Custom Size',
    NEED_HELP: 'Not sure / Need help',
    CHECK_AVAILABILITY: 'Availability confirmation',
    QUOTE_REQUIRED: 'Quotation / commercial review',
    ENGINEERING_REVIEW: 'Engineering review'
  };
  var MODE_BY_INQUIRY = {
    'Standard O-Rings': 'STANDARD',
    'Bulk quantity': 'BULK',
    'Custom Size': 'CUSTOM',
    'Custom by Drawing': 'CUSTOM',
    'Not sure / Need help': 'NEED_HELP',
    'Product documents': 'NEED_HELP',
    'Availability confirmation': 'CHECK_AVAILABILITY',
    'Quotation / commercial review': 'QUOTE_REQUIRED',
    'Engineering review': 'ENGINEERING_REVIEW',
    'Other sealing products / custom development': 'CUSTOM'
  };
  var REASON_LABELS = {
    manual_confirmation_required: 'Availability needs confirmation',
    quote_only_product: 'Quotation is required for this product',
    purchase_path_not_enabled: 'Purchase path needs review',
    finder_review_candidate: 'A same-size candidate needs review'
  };
  var MIME_BY_EXTENSION = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    pdf: 'application/pdf',
    webp: 'image/webp'
  };
  var MAX_FILE_BYTES = 20 * 1000 * 1000;
  var MAX_TOTAL_BYTES = 20 * 1000 * 1000;
  var WORKSHEET_CONTEXT_KEY = 'oxxring:measurement-worksheet:v1';
  var WORKSHEET_CONTEXT_VERSION = 1;
  var WORKSHEET_CONTEXT_MAX_AGE = 2 * 60 * 60 * 1000;

  function rfqSource(value) {
    var known = ['rfq_page', 'collection-ffkm', 'pdp-quote', 'pdp-application-check', 'pdp-engineer-pro',
      'finder', 'finder-review', 'material-guide', 'size-guide', 'compatibility',
      'application', 'engineering-tool', 'search'];
    var source = String(value || '');
    var publicSources = ["collection-fkm","collection-as568-o-rings","collection-din-iso-metric-o-rings","collection-silicone","collection-epdm","collection-shop-small-packs","drawer","footer","header","home-cta","home-fast-production","home-hero","home-intent","home-lanes","home-supply","home-tools","mobile-menu","nav","nav-materials","nav-side","rail","resources-answers","resources-vacuum","pdp","pdp-documents","pdp-material"];
    return known.indexOf(source) >= 0 || publicSources.indexOf(source) >= 0 ? source : 'other';
  }

  function emit(name, detail) {
    detail = Object.assign({}, detail || {});
    if (Object.prototype.hasOwnProperty.call(detail, 'source')) detail.source = rfqSource(detail.source);
    var payload = Object.assign({ event: name }, detail || {});
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.analyticsProcessingAllowed === 'function'
        && cp.analyticsProcessingAllowed() && window['ga-disable-G-LBH2238YVV'] !== true) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    }
    try { window.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); } catch (error) {}
  }

  function init(form) {
    if (!form || form.dataset.oxxRfqInitialized) return;
    form.dataset.oxxRfqInitialized = 'true';

    var params = new URLSearchParams(window.location.search);
    var errorBox = form.querySelector('[data-rfq-error]');
    var statusBox = form.querySelector('[data-rfq-status]');
    var statusTitle = form.querySelector('[data-rfq-status-title]');
    var statusMessage = form.querySelector('[data-rfq-status-message]');
    var summary = form.querySelector('[data-rfq-summary]');
    var summaryList = form.querySelector('[data-rfq-summary-list]');
    var submitButtons = Array.prototype.slice.call(form.querySelectorAll('[type="submit"]'));
    var submitButton = submitButtons[0] || null;
    var noFilesButton = form.querySelector('[data-rfq-send-without-files]');
    function setSubmitButtonsDisabled(disabled) {
      submitButtons.forEach(function (button) {
        button.disabled = disabled;
        if (disabled) button.setAttribute('aria-busy', 'true');
        else button.removeAttribute('aria-busy');
      });
    }
    function setSubmitButtonsText(text, updateIdle) {
      submitButtons.forEach(function (button) {
        if (updateIdle) button.dataset.idleLabel = text;
        button.textContent = text;
      });
    }
    // Named slots only: the unnamed dropzone picker (oxx-ic-wp1-rfq.js) is never submitted or validated.
    // Text-only requests use the OXXRING Worker and Titan SMTP; signed R2 links are included as one clean field.
    var fileInputs = Array.prototype.slice.call(form.querySelectorAll('input[type="file"][name]'));
    if (noFilesButton) {
      noFilesButton.addEventListener('click', function () {
        form.querySelectorAll('input[type="file"]').forEach(function (input) {
          try { input.value = ''; } catch (_) {}
        });
        var uploadedLinks = form.querySelector('[name="uploaded_file_links"]');
        if (uploadedLinks) uploadedLinks.value = '';
        noFilesButton.hidden = true;
        if (submitButton && typeof form.requestSubmit === 'function') form.requestSubmit(submitButton);
        else if (submitButton) submitButton.click();
      });
    }
    var copyRoot = form.closest('[data-rfq-root], .oxx-bulk-wrapper');
    function setCopy(map) {
      if (!copyRoot) return;
      Object.keys(map).forEach(function (key) {
        var element = copyRoot.querySelector('[data-rfq-copy="' + key + '"]') || copyRoot.querySelector({ h1: '.oxx-bulk-h1', lead: '.oxx-bulk-subheading', h2: '.oxx-bulk-h2', helper: '.oxx-bulk-helper' }[key]);
        if (element) element.textContent = map[key];
      });
    }
    function relabelInquiry(value, text) {
      var control = field('inquiry');
      if (control && control.options) {
        Array.prototype.forEach.call(control.options, function (option) { if (option.value === value) option.textContent = text; });
        return;
      }
      Array.prototype.forEach.call(form.querySelectorAll('input[name="inquiry"]'), function (radio) {
        var label = radio.value === value && radio.parentNode.querySelector('[data-rfq-chip-label]');
        if (label) label.textContent = text;
      });
    }
    var acceptedFiles = new WeakMap();
    var ajaxSubmissionPending = false;
    var mode = 'NEED_HELP';
    var originMode = mode;
    var requestSummary = [];

    function field(name) { return form.elements.namedItem(name) || (name === 'email' ? form.querySelector('[data-rfq-email]') : null); }
    function query(name, max) {
      return String(params.get(name) || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, max);
    }
    function fill(name, value) {
      var input = field(name);
      if (!input || input.value || !value) return;
      input.value = input.maxLength >= 0 ? value.slice(0, input.maxLength) : value;
    }
    function setHidden(name, value) {
      var input = field(name);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }
      input.value = value || '';
      return input;
    }
    function buildWorkerPayload(requestId) {
      var data = new FormData(form);
      function value(name, max) {
        var raw = data.get(name);
        if (typeof File !== 'undefined' && raw instanceof File) return '';
        return String(raw == null ? '' : raw).replace(/\r\n?/g, '\n').trim().slice(0, max || 4000);
      }
      var fieldNames = [
        'name', 'company', 'phone_whatsapp', 'inquiry', 'production_timing', 'origin_request_mode', 'size_or_sku', 'product_sku',
        'selected_pack', 'pack_count', 'quantity', 'material', 'hardness', 'product_type',
        'application', 'operating_temperature', 'operating_pressure', 'motion',
        'hardware_gland', 'drawing_link', 'uploaded_file_links', 'notes', 'route_state',
        'route_reason', 'document_request', 'product_id', 'product_handle', 'resolution_context_id',
        'selected_variant', 'pack_price', 'unit_reference', 'availability_state',
        'worksheet_context_loaded', 'measurement_reference', 'ring_condition',
        'fluid_medium', 'service_temperature', 'movement_type', 'measurement_notes'
      ];
      var limits = {
        name: 120, company: 160, phone_whatsapp: 64, inquiry: 120, production_timing: 160,
        size_or_sku: 160, product_sku: 120, selected_pack: 120, pack_count: 24,
        quantity: 24, material: 120, hardness: 80, product_type: 160,
        application: 4000, operating_temperature: 160, operating_pressure: 160,
        motion: 120, hardware_gland: 240, drawing_link: 1800,
        uploaded_file_links: 6000, notes: 4000, measurement_notes: 1600
      };
      var fields = {};
      fieldNames.forEach(function (name) {
        var item = value(name, limits[name] || 500);
        if (item) fields[name] = item;
      });

      var attributionNames = [
        'first_observed_landing_path', 'first_observed_at', 'attribution_scope',
        'attribution_expires_at', 'first_touch_source', 'first_touch_medium',
        'first_touch_campaign', 'first_touch_landing_path', 'first_touch_referrer_host',
        'first_touch_at', 'first_touch_click_id_type', 'first_touch_click_id_value',
        'last_touch_source', 'last_touch_medium', 'last_touch_campaign',
        'last_touch_landing_path', 'last_touch_referrer_host', 'last_touch_at',
        'last_touch_click_id_type', 'last_touch_click_id_value', 'referrer_host',
        'source', 'medium', 'campaign', 'attribution_click_id_type',
        'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id',
        'utm_source_platform', 'utm_creative_format', 'utm_marketing_tactic',
        'last_utm_source', 'last_utm_medium', 'last_utm_campaign', 'last_utm_term',
        'last_utm_content', 'last_utm_id', 'last_utm_source_platform',
        'last_utm_creative_format', 'last_utm_marketing_tactic', 'gclid', 'gbraid',
        'wbraid', 'dclid', 'fbclid', 'msclkid', 'ttclid', 'twclid', 'li_fat_id',
        'epik', 'sccid', 'sc_cid', 'rdt_cid', 'qclid', 'yclid', 'bd_vid', 'tblci',
        'dicbo', 'srsltid', 'irclickid', 'cjevent', 'awc', 'gclsrc', 'gad_source',
        'gad_campaignid'
      ];
      var attribution = {};
      attributionNames.forEach(function (name) {
        var item = value(name, 300);
        if (item) attribution[name] = item;
      });

      return {
        requestId: String(requestId || 'Not available'),
        email: value('email', 254),
        requestMode: String(mode || 'NEED_HELP'),
        requestSource: rfqSource(value('request_source', 120) || source || 'rfq_page'),
        pagePath: window.location.pathname || '/pages/bulk-quote',
        submittedAt: value('submitted_at', 50) || new Date().toISOString(),
        fields: fields,
        attribution: attribution,
        honeypot: value('_honey', 200)
      };
    }

    function readWorksheetContext() {
      try {
        var raw = window.sessionStorage && window.sessionStorage.getItem(WORKSHEET_CONTEXT_KEY);
        if (!raw) return null;
        var value = JSON.parse(raw);
        if (!value || value.version !== WORKSHEET_CONTEXT_VERSION || !Number.isFinite(Number(value.saved_at))) return null;
        if (Date.now() - Number(value.saved_at) > WORKSHEET_CONTEXT_MAX_AGE) { window.sessionStorage.removeItem(WORKSHEET_CONTEXT_KEY); return null; }
        return value;
      } catch (_) { return null; }
    }
    function worksheetContextMatches(value) {
      if (!value) return false;
      if (params.get('worksheet_context') === '1') return true;
      if (!dimensionsAreValid || !value.id || !value.cs) return false;
      var sourceScale = value.units === 'in' ? 25.4 : 1;
      var currentScale = unitLabel === 'in' ? 25.4 : 1;
      return Math.abs(Number(value.id) * sourceScale - Number(id) * currentScale) <= 0.01
        && Math.abs(Number(value.cs) * sourceScale - Number(cs) * currentScale) <= 0.01;
    }
    function appendNotes(value) {
      var notes = field('notes');
      if (!notes || !value) return;
      var lines = [];
      if (value.reference) lines.push('Reference: ' + String(value.reference).slice(0, 120));
      if (value.ring_condition) lines.push('Ring condition: ' + String(value.ring_condition).slice(0, 120));
      if (value.fluid) lines.push('Fluid / medium: ' + String(value.fluid).slice(0, 180));
      if (value.temperature) lines.push('Temperature: ' + String(value.temperature).slice(0, 100));
      if (value.movement) lines.push('Movement: ' + String(value.movement).slice(0, 120));
      if (value.notes) lines.push('Measurement notes: ' + String(value.notes).slice(0, 1500));
      if (!lines.length) return;
      var marker = '[Measurement worksheet context]';
      if (notes.value.indexOf(marker) >= 0) return;
      notes.value = [notes.value, marker, lines.join('\n')].filter(Boolean).join('\n');
    }
    function setError(message) {
      if (!errorBox) return;
      errorBox.hidden = !message;
      errorBox.textContent = message || '';
    }
    function setStatus(state, title, message) {
      if (!statusBox) return;
      statusBox.hidden = !state;
      statusBox.dataset.state = state || '';
      if (statusTitle) statusTitle.textContent = title || '';
      if (statusMessage) statusMessage.textContent = message || '';
    }
    function addSummary(label, value) {
      if (!value) return;
      requestSummary.push({ label: label, value: String(value) });
    }
    function renderSummary() {
      if (!summary || !summaryList) return;
      summaryList.textContent = '';
      requestSummary.forEach(function (item) {
        var row = document.createElement('div');
        var term = document.createElement('dt');
        var value = document.createElement('dd');
        term.textContent = item.label;
        value.textContent = item.value;
        row.appendChild(term);
        row.appendChild(value);
        summaryList.appendChild(row);
      });
      summary.hidden = requestSummary.length === 0;
    }
    function updateModeSummary() {
      var row = requestSummary.find(function (item) { return item.label === 'Request type'; });
      if (row) row.value = MODE_LABELS[mode] || MODE_LABELS.BULK;
      else if (requestSummary.length) requestSummary.unshift({ label: 'Request type', value: MODE_LABELS[mode] || MODE_LABELS.BULK });
      renderSummary();
    }
    function updateFileLabel(input) {
      var card = input.closest('.oxx-bulk-file-card');
      var nameNode = card && card.querySelector('.oxx-bulk-file-card__name');
      if (!nameNode) return;
      var selected = input.files && input.files[0];
      nameNode.textContent = selected ? selected.name : (nameNode.getAttribute('data-default-text') || 'No file selected');
      card.classList.toggle('is-selected', Boolean(selected));
    }
    function validateFiles() {
      var total = 0;
      for (var i = 0; i < fileInputs.length; i += 1) {
        var files = fileInputs[i].files;
        if (!files || !files.length) continue;
        if (files.length !== 1) return 'Please choose one file per attachment slot.';
        var file = files[0];
        var extension = (file.name || '').split('.').pop().toLowerCase();
        var expectedMime = Object.prototype.hasOwnProperty.call(MIME_BY_EXTENSION, extension) && MIME_BY_EXTENSION[extension];
        if (file.name.indexOf('.') < 0 || !expectedMime || (file.type && file.type.toLowerCase() !== expectedMime)) {
          return 'Unsupported or mismatched file type. Use JPG, JPEG, PNG, PDF, or WEBP.';
        }
        if (!file.size) return 'This file is empty. Please choose a different file.';
        if (file.size > MAX_FILE_BYTES) return 'Each file must be 20 MB or smaller.';
        total += file.size;
      }
      return total > MAX_TOTAL_BYTES ? 'Total upload size must stay within 20 MB. Your previous attachments have been kept.' : '';
    }
    function restoreAcceptedFile(input) {
      var previous = acceptedFiles.get(input);
      input.value = '';
      if (previous && typeof DataTransfer === 'function') {
        try {
          var transfer = new DataTransfer();
          transfer.items.add(previous);
          input.files = transfer.files;
        } catch (error) { acceptedFiles.delete(input); }
      } else if (previous) {
        acceptedFiles.delete(input);
      }
      updateFileLabel(input);
    }
    function ensureRequestId() {
      var requestId = field('request_id');
      if (!requestId.value) {
        requestId.value = window.crypto && window.crypto.randomUUID
          ? window.crypto.randomUUID()
          : 'oxx-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
      }
      return requestId.value;
    }
    function recordSubmissionContext() {
      var now = new Date().toISOString();
      setHidden('submitted_at', (field('submitted_at') && field('submitted_at').value) || now);
      setHidden('last_submit_attempt_at', now);
      setHidden('submission_page_path', window.location.pathname || '/pages/bulk-quote');
      var context = typeof window.oxxAttributionContext === 'function' ? window.oxxAttributionContext() : null;
      [
        'first_observed_landing_path', 'first_observed_at', 'attribution_scope', 'attribution_expires_at',
        'first_touch_source', 'first_touch_medium', 'first_touch_campaign', 'first_touch_landing_path',
        'first_touch_referrer_host', 'first_touch_at', 'first_touch_click_id_type', 'first_touch_click_id_value',
        'last_touch_source', 'last_touch_medium', 'last_touch_campaign', 'last_touch_landing_path',
        'last_touch_referrer_host', 'last_touch_at', 'last_touch_click_id_type', 'last_touch_click_id_value',
        'referrer_host', 'source', 'medium', 'campaign', 'attribution_click_id_type',
        'ga4_client_id', 'ga4_session_id',
        'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id',
        'utm_source_platform', 'utm_creative_format', 'utm_marketing_tactic',
        'last_utm_source', 'last_utm_medium', 'last_utm_campaign', 'last_utm_term', 'last_utm_content', 'last_utm_id',
        'last_utm_source_platform', 'last_utm_creative_format', 'last_utm_marketing_tactic',
        'gclid', 'gbraid', 'wbraid', 'dclid', 'fbclid', 'msclkid', 'ttclid', 'twclid', 'li_fat_id',
        'epik', 'sccid', 'sc_cid', 'rdt_cid', 'qclid', 'yclid', 'bd_vid', 'tblci', 'dicbo',
        'srsltid', 'irclickid', 'cjevent', 'awc', 'gclsrc', 'gad_source', 'gad_campaignid'
      ].forEach(function (key) {
        setHidden(key, context && context[key] || '');
      });
    }

    var id = query('id', 24);
    var cs = query('cs', 24);
    var units = (query('unit', 8) || query('units', 8)).toLowerCase();
    var unitLabel = units === 'in' || units === 'inch' ? 'in' : 'mm';
    var validDimension = /^(?:(?:\d{1,8}(?:\.\d{0,8})?)|(?:\.\d{1,8}))$/;
    var dimensionsAreValid = validDimension.test(id) && validDimension.test(cs) && Number(id) > 0 && Number(cs) > 0;
    var dimensionText = dimensionsAreValid ? id + ' × ' + cs + ' ' + unitLabel : '';
    var standard = query('standard', 80);
    var standardCode = query('standard_code', 40);
    var standardLabel = standard === 'ISO3601' && query('standard_class', 8) === 'B' ? 'ISO 3601 Class B' : standard;
    var standardSpec = [standardLabel, standardCode].filter(Boolean).join(' ');
    var product = query('product', 160);
    var variant = query('variant', 24);
    var sku = query('sku', 120);
    var quantity = query('quantity', 10);
    var packSize = query('pack_size', 10);
    var packs = query('packs', 10);
    var source = query('source', 200);
    var routeState = query('route_state', 40).toUpperCase();
    var routeReason = query('route_reason', 120).toLowerCase();
    var incomingMode = query('request_mode', 32).toUpperCase();
    var isApplicationReview = incomingMode === 'APPLICATION_REVIEW';
    var applicationMedia = query('media', 300);
    var applicationTemperature = query('temperature', 200);
    var applicationPressure = query('pressure', 200);
    var applicationMotion = query('motion', 160);
    var applicationHardware = query('hardware', 500);
    var applicationSpecial = query('special', 500);
    var applicationRoute = query('application', 240);
    var handoffContext = query('context', 1600);
    if (routeState === 'REVIEW_REQUIRED') routeState = 'ENGINEERING_REVIEW';
    if (isApplicationReview) {
      mode = 'ENGINEERING_REVIEW';
      originMode = 'APPLICATION_REVIEW';
    } else {
      if (product && ['QUOTE_REQUIRED', 'CHECK_AVAILABILITY', 'CUSTOM', 'ENGINEERING_REVIEW'].indexOf(routeState) >= 0) mode = routeState;
      else if (ALLOWED_MODES.indexOf(incomingMode) >= 0) mode = incomingMode;
      else if (ALLOWED_MODES.indexOf(routeState) >= 0) mode = routeState;
      originMode = mode;
    }

    fill('size_or_sku', [standardSpec, dimensionText].filter(Boolean).join(' · ') || query('size_or_sku', 160) || product);
    fill('material', query('material', 120));
    fill('hardness', query('hardness', 80));
    var kitRequest = query('type', 16).toLowerCase() === 'kit';
    if (kitRequest) fill('product_type', 'O-ring kit');
    fill('request_source', source);
    fill('route_state', routeState);
    fill('route_reason', routeReason);
    fill('product_handle', product);
    fill('product_sku', sku);
    fill('selected_pack', packSize);
    fill('pack_count', packs);
    fill('pack_price', query('pack_price', 32));
    fill('unit_reference', query('unit_reference', 32));
    fill('availability_state', query('availability_state', 80));
    if (/^\d{1,24}$/.test(query('product_id', 24))) fill('product_id', query('product_id', 24));
    if (/^\d{1,24}$/.test(variant)) fill('selected_variant', variant);
    if (/^[1-9]\d{0,9}$/.test(quantity) && Number(quantity) <= 1000000000) fill('quantity', quantity);
    var contextId = query('resolution_context_id', 160);
    if (/^[a-zA-Z0-9._:-]{1,160}$/.test(contextId)) fill('resolution_context_id', contextId);

    var reviewCandidate = query('review_candidate', 160);
    if (/^[a-z0-9-]{1,160}$/.test(reviewCandidate)) {
      mode = 'ENGINEERING_REVIEW';
      originMode = mode;
      if (!routeState) fill('route_state', 'ENGINEERING_REVIEW');
      if (!routeReason) fill('route_reason', 'finder_review_candidate');
      fill('product_handle', reviewCandidate);
      fill('notes', 'Please review a same-dimension candidate against my requested specification above. Candidate: ' + reviewCandidate + '. Candidate material: ' + query('candidate_material', 40) + '; hardness: ' + query('candidate_hardness', 20) + ' Shore A. This candidate has not been confirmed as a suitable replacement.');
    }

    var documentRequest = query('document_request', 8) === '1';
    if (documentRequest) {
      mode = 'NEED_HELP';
      originMode = mode;
      fill('document_request', '1');
      fill('notes', 'Please send the available product datasheet, material datasheet or technical drawing for this specification.');
      setCopy({
        h1: 'Request product documents',
        lead: 'Tell us which file or technical information you need for this product.',
        h2: 'Your document request',
        helper: 'Your product details are filled in. Add your contact details and any document requirements below.'
      });
      setSubmitButtonsText('Request documents', true);
    }

    var isEngineeringReviewFlow = mode === 'ENGINEERING_REVIEW';

    if (isEngineeringReviewFlow && !documentRequest) {
      setHidden('service_media', applicationMedia);
      setHidden('operating_temperature', applicationTemperature);
      setHidden('operating_pressure', applicationPressure);
      setHidden('motion', applicationMotion);
      setHidden('hardware_gland', applicationHardware);
      setHidden('special_requirements', applicationSpecial);
      setHidden('application_route', applicationRoute);
      setHidden('handoff_context', handoffContext);

      setCopy({
        h1: 'Request an application review',
        lead: 'Known details from the previous tool are already carried over. Add your contact details and fill only what is still missing.',
        h2: 'Application review details',
        helper: 'Review the carried details below, then add only what is missing or has changed.'
      });

      relabelInquiry('Engineering review', 'Application review');

      var applicationLines = [];
      if (applicationRoute) applicationLines.push('Application / diagnostic route: ' + applicationRoute);
      if (handoffContext) applicationLines.push('Carried context: ' + handoffContext);
      if (applicationMedia) applicationLines.push('Service media: ' + applicationMedia);
      if (applicationTemperature) applicationLines.push('Operating temperature: ' + applicationTemperature);
      if (applicationPressure) applicationLines.push('Operating pressure: ' + applicationPressure);
      if (applicationMotion) applicationLines.push('Motion: ' + applicationMotion);
      if (applicationHardware) applicationLines.push('Hardware / gland: ' + applicationHardware);
      if (applicationSpecial) applicationLines.push('Special requirements: ' + applicationSpecial);
      var applicationField = field('application');
      if (applicationField && applicationLines.length) {
        applicationField.value = 'Application review details:\n' + applicationLines.join('\n');
      }
      setSubmitButtonsText('Send for application review', true);
    }

    if (!isEngineeringReviewFlow && !documentRequest && (applicationRoute || handoffContext)) {
      setHidden('application_route', applicationRoute);
      setHidden('handoff_context', handoffContext);
      var carriedField = field('application');
      if (carriedField) {
        var carriedLines = [];
        if (applicationRoute) carriedLines.push('Application / diagnostic route: ' + applicationRoute);
        if (handoffContext) carriedLines.push('Carried context: ' + handoffContext);
        carriedField.value = [carriedField.value, carriedLines.join('\n')].filter(Boolean).join('\n');
      }
    }

    var originalId = query('original_id', 24);
    var originalCs = query('original_cs', 24);
    if (query('original_unit', 8) === 'in' && validDimension.test(originalId) && validDimension.test(originalCs) && Number(originalId) > 0 && Number(originalCs) > 0) {
      var originalNote = 'Original entered dimensions: ID ' + originalId + ' × CS ' + originalCs + ' in. The specification above is converted to mm.';
      var notesField = field('notes');
      if (notesField) notesField.value = [notesField.value, originalNote].filter(Boolean).join('\n');
    }

    var worksheetContext = readWorksheetContext();
    if (worksheetContextMatches(worksheetContext)) {
      fill('worksheet_context_loaded', '1');
      fill('measurement_reference', String(worksheetContext.reference || '').slice(0, 120));
      fill('ring_condition', String(worksheetContext.ring_condition || '').slice(0, 120));
      fill('fluid_medium', String(worksheetContext.fluid || '').slice(0, 180));
      fill('service_temperature', String(worksheetContext.temperature || '').slice(0, 100));
      fill('movement_type', String(worksheetContext.movement || '').slice(0, 120));
      fill('measurement_notes', String(worksheetContext.notes || '').slice(0, 1500));
      appendNotes(worksheetContext);
    }

    field('request_mode').value = mode;
    field('origin_request_mode').value = originMode;
    var inquiry = field('inquiry');
    // Without explicit context, an email-only enquiry stays general instead of being mislabeled as a standard order.
    var modeIsDefault = mode === 'NEED_HELP' && !incomingMode && !routeState;
    if (inquiry) {
      inquiry.value = documentRequest ? 'Product documents' : (modeIsDefault ? 'Not sure / Need help' : (INQUIRY_BY_MODE[mode] || 'Not sure / Need help'));
      if (!inquiry.value) inquiry.value = 'Not sure / Need help';
      // Delegated so it works for the chip radios (RadioNodeList) and the older <select>.
      form.addEventListener('change', function (event) {
        if (!event.target || event.target.name !== 'inquiry') return;
        mode = MODE_BY_INQUIRY[event.target.value] || 'NEED_HELP';
        field('request_mode').value = mode;
        updateModeSummary();
      });
    }

    var hasIncomingContext = Boolean(incomingMode || routeState || product || reviewCandidate || documentRequest || dimensionText || standardSpec || sku || quantity || source || kitRequest);
    if (hasIncomingContext) addSummary('Request type', isEngineeringReviewFlow ? 'Application review' : (modeIsDefault && !documentRequest ? MODE_LABELS.NEED_HELP : (MODE_LABELS[mode] || MODE_LABELS.NEED_HELP)));
    addSummary('Product', reviewCandidate || product);
    addSummary('Product type', kitRequest ? 'O-ring kit' : '');
    addSummary('Variant', /^\d{1,24}$/.test(variant) ? variant : '');
    addSummary('SKU', sku);
    addSummary('Standard', standardSpec);
    addSummary('Size (ID × CS)', dimensionText);
    addSummary('Material', query('material', 120));
    addSummary('Hardness', query('hardness', 80));
    addSummary('Quantity', /^[1-9]\d{0,9}$/.test(quantity) ? quantity + ' pieces' : '');
    addSummary('Pack', /^[1-9]\d{0,9}$/.test(packSize) ? packSize + ' pieces' : '');
    addSummary('Packs', /^[1-9]\d{0,9}$/.test(packs) ? packs : '');
    addSummary('Reason', REASON_LABELS[routeReason] || '');
    if (isEngineeringReviewFlow) {
      addSummary('Application / diagnostic route', applicationRoute);
      addSummary('Carried context', handoffContext);
      addSummary('Service media', applicationMedia);
      addSummary('Operating temperature', applicationTemperature);
      addSummary('Operating pressure', applicationPressure);
      addSummary('Motion', applicationMotion);
      addSummary('Hardware / gland', applicationHardware);
      addSummary('Special requirements', applicationSpecial);
    }
    if (worksheetContextMatches(worksheetContext)) {
      addSummary('Reference', worksheetContext.reference || '');
      addSummary('Ring condition', worksheetContext.ring_condition || '');
      addSummary('Fluid / medium', worksheetContext.fluid || '');
      addSummary('Temperature', worksheetContext.temperature || '');
      addSummary('Movement', worksheetContext.movement || '');
      addSummary('Measurement notes', worksheetContext.notes || '');
    }
    renderSummary();

    fileInputs.forEach(function (input) {
      if (input.files && input.files[0]) acceptedFiles.set(input, input.files[0]);
      updateFileLabel(input);
      input.addEventListener('change', function () {
        var error = validateFiles();
        if (error) restoreAcceptedFile(input);
        else if (input.files && input.files[0]) acceptedFiles.set(input, input.files[0]);
        else acceptedFiles.delete(input);
        updateFileLabel(input);
        setError(error);
      });
    });

    var nameInput = field('name');
    function validateName() { nameInput.setCustomValidity(''); }
    nameInput.addEventListener('input', validateName);

    ensureRequestId();

    // Verified Titan mail fallback: the browser cannot transfer selected local File objects
    // into a mailto composer, so the UI explicitly tells customers to reattach their drawings.
    var directAttachmentEmail = form.querySelector('[data-rfq-email-fallback]');
    if (directAttachmentEmail) {
      directAttachmentEmail.addEventListener('click', function () {
        var subject = 'OXXRING RFQ drawings - ' + ensureRequestId();
        function mailValue(name, max) {
          var input = field(name);
          return String(input && input.value || '').trim().slice(0, max);
        }
        var body = [
          'OXXRING RFQ request reference: ' + ensureRequestId(),
          'Name: ' + mailValue('name', 120),
          'Email: ' + mailValue('email', 254),
          'Size / SKU: ' + mailValue('size_or_sku', 160),
          'Material: ' + mailValue('material', 120),
          'Hardness: ' + mailValue('hardness', 80),
          'Quantity: ' + mailValue('quantity', 24),
          'Application: ' + mailValue('application', 600),
          'Drawing download link: ' + mailValue('drawing_link', 1800),
          'Files already uploaded to OXXRING (download links): ' + mailValue('uploaded_file_links', 4000),
          '',
          mailValue('uploaded_file_links', 4000) ? 'The files linked above are already uploaded. You do not need to attach them again.' : 'PLEASE ATTACH your drawings or photos to this email. Files selected in the web form are NOT automatically attached.',
          'This email option is separate from the web form. Only send once.'
        ].join('\n');
        directAttachmentEmail.href = 'mailto:support@oxxring.com?subject='
          + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
      });
    }

    form.addEventListener('submit', async function (event) {
      if (ajaxSubmissionPending || form.dataset.submissionState === 'receiver_accepted') {
        event.preventDefault(); return;
      }
      setError('');
      var honeypot = field('_honey');
      if (honeypot && honeypot.value.trim()) {
        event.preventDefault();
        setError('Unable to submit this request.');
        return;
      }
      var fileError = validateFiles();
      if (fileError) {
        event.preventDefault();
        setError(fileError);
        if (noFilesButton) noFilesButton.hidden = false;
        return;
      }
      validateName();
      if (!form.checkValidity()) {
        event.preventDefault();
        form.reportValidity();
        return;
      }
      var textFields = form.querySelectorAll('input[type="text"], input[type="email"], textarea');
      for (var i = 0; i < textFields.length; i += 1) {
        if (textFields[i].maxLength >= 0 && textFields[i].value.length > textFields[i].maxLength) {
          event.preventDefault();
          setError('Please shorten one or more fields before submitting.');
          textFields[i].focus();
          return;
        }
      }
      var requestId = ensureRequestId();
      recordSubmissionContext();
      var hasFiles = fileInputs.some(function (input) { return input.files && input.files.length; });
      if (hasFiles) {
        event.preventDefault();
        if (noFilesButton) noFilesButton.hidden = false;
        setStatus('failed', 'Attachments are not ready',
          'You can still send your quote request without files. Choose “Send request without files” or remove the attachments and try again.');
        emit('oxx_rfq_submit_failed', {
          request_id: requestId, request_mode: mode, source: source || 'rfq_page',
          reason: 'attachment_transport_unavailable'
        });
        return;
      }
      if (!window.fetch || !window.FormData) {
        event.preventDefault();
        setStatus('failed', 'Request not sent', 'Please email us directly using the email link on this page.');
        return;
      }

      event.preventDefault();
      ajaxSubmissionPending = true;
      form.dataset.submissionState = 'submitting';
      setSubmitButtonsDisabled(true);
      var activeSubmitButton = event.submitter || submitButton;
      if (activeSubmitButton) {
        activeSubmitButton.dataset.idleLabel = activeSubmitButton.dataset.idleLabel || activeSubmitButton.textContent;
        activeSubmitButton.textContent = 'Sending request…';
      }
      setStatus('submitting', 'Sending your request', 'Keep this page open while your request is sent.');
      emit('oxx_rfq_submit_attempt', { request_id: requestId, request_mode: mode, source: source || 'rfq_page', transport: 'cloudflare_worker_titan_smtp' });

      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timeout = controller ? window.setTimeout(function () { controller.abort(); }, 45000) : null;
      try {
        var response = await fetch(form.action, {
          method: 'POST',
          body: JSON.stringify(buildWorkerPayload(requestId)),
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'omit',
          cache: 'no-store',
          signal: controller ? controller.signal : undefined
        });
        var payload = null;
        try { payload = await response.json(); } catch (parseError) {}
        if (response.ok && payload && payload.ok === true && payload.duplicate === true) {
          form.dataset.submissionState = 'receiver_accepted';
          setSubmitButtonsText('Request already received', false);
          setStatus('accepted', 'Request already received',
            'We already received this request. Our team will reply by email. Reference: ' + requestId + '.');
          return; // Same request must not create a second conversion.
        }
        if (response.ok && payload && payload.ok === true && payload.pending === true) {
          form.dataset.submissionState = 'pending';
          setSubmitButtonsDisabled(false);
          setSubmitButtonsText('Retry if no confirmation', false);
          setStatus('submitting', 'Request processing',
            'Your request is still processing, not yet confirmed. Keep your reference: ' + requestId + '.');
          return; // A queued/sending receipt is NOT an SMTP acceptance.
        }
        var accepted = response.status === 200 && payload && payload.ok === true &&
          payload.accepted === true && payload.delivery === 'smtp_accepted' &&
          payload.discarded !== true;
        if (!accepted) {
          var receiverError = new Error('receiver_rejected');
          receiverError.code = payload && payload.error || '';
          throw receiverError;
        }
        form.dataset.submissionState = 'receiver_accepted';
        setSubmitButtonsText('Request received', false);
        setStatus('accepted', 'Request received',
          'Your request has been sent to OXXRING. Our team will reply by email. Reference: ' + requestId + '.');
        var emailForQa = String((field('email') && field('email').value) || '').trim().toLowerCase();
        var notesForQa = String((field('notes') && field('notes').value) || '');
        var internalQa = emailForQa === 'support@oxxring.com' ||
          /internal\s+test\s+only|do\s+not\s+quote\s+or\s+ship/i.test(notesForQa) ||
          params.get('oxx_internal_qa') === '1';
        var verifiedReceipt = { request_id: requestId, request_mode: mode,
          source: source || 'rfq_page', transport: 'cloudflare_worker_titan_smtp',
          receipt_type: 'smtp_accepted' };
        // SMTP acceptance is a receiver event, NOT proof of a sales-qualified lead.
        // The existing CRM qualification gate owns qualified_quote_submit.
        if (internalQa) verifiedReceipt.qa_only = true;
        emit('oxx_rfq_receiver_accepted', verifiedReceipt);
      } catch (error) {
        form.dataset.submissionState = 'failed';
        setSubmitButtonsDisabled(false);
        setSubmitButtonsText('Try sending again', false);
        var message = error && error.name === 'AbortError'
          ? 'The connection timed out. Your details are still here; please try again.'
          : error && error.code === 'rate_limited'
            ? 'Please wait a moment before sending another request. Your details are still here.'
            : error && error.code === 'uploaded_file_unavailable'
              ? 'One or more uploaded files could not be verified. Remove and upload those files again, or send your request without files.'
              : 'We could not send your request right now. Your details are still here; please try again or email us directly.';
        setStatus('failed', 'Request not sent', message);
        emit('oxx_rfq_submit_failed', { request_id: requestId, request_mode: mode, source: source || 'rfq_page', reason: error && error.name === 'AbortError' ? 'timeout' : 'network_or_receiver' });
      } finally {
        ajaxSubmissionPending = false;
        if (timeout) window.clearTimeout(timeout);
        submitButtons.forEach(function (button) { button.removeAttribute('aria-busy'); });
      }
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-oxx-rfq]'), init);
    if (root && root.matches && root.matches('[data-oxx-rfq]')) init(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
